module.exports = __webpack_public_path__ + "media/home3-right.40d4f525.mp4";